import React from 'react';

import {TPlacementX, TPlacementY} from '../types';

type TFluidOverlayPlacement = {
  placementX?: TPlacementX;
  placementY?: TPlacementY;
  ref: React.RefObject<HTMLElement>;
  headRef?: React.RefObject<HTMLDivElement>;
};

const RESERVE = 20;

const useFluidOverlayPlacement = ({
  ref,
  headRef,
  placementX: originalPlacementX,
  placementY: originalPlacementY = 'bottom',
}: TFluidOverlayPlacement) => {
  const [placementY, setPlacementY] = React.useState(originalPlacementY);
  const [placementX, setPlacementX] = React.useState(originalPlacementX);

  const updatePlacement = () => {
    if (!ref?.current) {
      return;
    }

    const position = ref.current.getBoundingClientRect();
    let referencePlacementX: TPlacementX | null = null;

    if (!originalPlacementX && headRef?.current) {
      const headRect = headRef.current.getBoundingClientRect();
      const headCenter = headRect.x + headRect.width / 2;
      const documentCenter = document.documentElement.offsetWidth / 2;

      referencePlacementX = headCenter > documentCenter ? 'right' : 'left';
    } else {
      referencePlacementX = originalPlacementX ?? 'left';
    }

    if (originalPlacementY === 'top' && position.top - RESERVE <= 0) {
      setPlacementY('bottom');
    }

    if (
      originalPlacementY === 'bottom' &&
      position.top + position.height + RESERVE >= document.documentElement.clientHeight
    ) {
      setPlacementY('top');
    }

    if (
      ['center', 'left'].includes(referencePlacementX) &&
      position.left + position.width + RESERVE >= document.documentElement.clientWidth
    ) {
      return setPlacementX('right');
    }

    if (['center', 'right'].includes(referencePlacementX) && position.left - RESERVE <= 0) {
      return setPlacementX('left');
    }

    if (originalPlacementX !== referencePlacementX) {
      setPlacementX(referencePlacementX);
    }
  };

  React.useLayoutEffect(() => {
    if (ref?.current) {
      updatePlacement();
    }
  }, []);

  return {placementX, placementY};
};

export {useFluidOverlayPlacement};
